<template>
  <b-form-group
    label="Kategori"
    label-for="categoryWhat"
  >
    <div>
      <b-form-checkbox
        v-for="category in categories"
        :key="category.id"
        :id="`category-${category.id}`"
        :value="category.id"
        v-model="selectedCategories"
        @change="updateIsHome"
      >
        {{ category.title }}
      </b-form-checkbox>
    </div>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'CategoryWhat',
  components: {
    BFormGroup,
    BFormCheckbox,
  },
  data() {
    return {
      dynamicCategories: [],
      fixedCategories: [
        { id: 3, title: 'Devam Eden Projeler' },
        { id: 4, title: 'Tamamlanan Projeler' },
      ],
      selectedCategories: [],
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['products/dataItem']
    },
    categories() {
      return [...this.dynamicCategories, ...this.fixedCategories]
    },
  },
  created() {
    this.getCategories()
  },
  watch: {
    'itemData.is_home': {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          // Parse comma-separated string to array
          this.selectedCategories = String(newValue)
            .split(',')
            .map(id => parseInt(id.trim()))
            .filter(id => !isNaN(id))
        } else {
          this.selectedCategories = []
        }
      },
    },
  },
  methods: {
    async getCategories() {
      const data = await this.$store.dispatch('productGroups/getDataList2', {
        select: [
          'product_categories.id AS id',
          'product_categories.title AS title',
          'pc.title AS product_group',
        ],
        where: {
          'product_categories.id_product_categories !=': null,
        },
        order_by: [
          'product_categories.ordering', 'ASC',
        ],
      })
      this.dynamicCategories = data || []
    },
    updateIsHome() {
      // Tüm seçilen kategorileri virgülle ayrılmış string olarak sakla
      // Backend'e gönderilirken saveData action'ında sadece ilk değer integer'a çevrilecek
      if (this.selectedCategories.length > 0) {
        this.itemData.is_home = this.selectedCategories.join(',')
      } else {
        this.itemData.is_home = null
      }
    },
  },
}
</script>
